// This file was generated by "make codegen/iam". DO NOT EDIT.
// source: <server_repo_dir>/captain/captain.actions.go

import { type ReactNode } from "react";
import { type Scope } from "~/hooks/useScope";
import { useCanCreateSpace } from "./hook";

export type CanCreateSpaceProps = {
  children?: ReactNode;
  fallback?: ReactNode;
  scope?: Scope;
};

export function CanCreateSpace({
  children,
  fallback,
  scope,
}: CanCreateSpaceProps) {
  const canDoAction = useCanCreateSpace(scope);
  return <>{canDoAction ? children : fallback}</>;
}
